import { mergeMap, tap } from 'rxjs/operators';
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { selectEventCapturedsInStore, selectEventCapturedsPageLoading, selectEventCapturedsShowInitWaitingMessage } from '../_selectors/EventCaptured.selectors';


export class EventCapturedsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
        super();

		this.loading$ = this.store.pipe(
			select(selectEventCapturedsPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectEventCapturedsShowInitWaitingMessage)
        );
        
        this.store.pipe(
			select(selectEventCapturedsInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});

    }
}